// extracted by mini-css-extract-plugin
export default {"Pager":"GVK2GVKT","PagerContent":"HmUnqEi7","sr-only":"TUTnP3NI"};